import React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { makeStyles } from '@mui/styles';
import { Trans, useTranslation } from 'react-i18next'
import classnames from 'classnames'

const ListCountry = [
    { code: 'US', value: 'USA', label: 'United States', phone: '1' },
    { code: 'HK', value: 'HKG', label: 'Hong Kong', phone: '852' },
    { code: 'AU', value: 'AUS', label: 'Australia', phone: '61' },
    { code: 'AT', value: 'AUT', label: 'Austria', phone: '43' },
    { code: 'BE', value: 'BEL', label: 'Belgium', phone: '32' },
    { code: 'CA', value: 'CAD', label: 'Canada', phone: '1' },
    { code: 'CN', value: 'CHN', label: 'China', phone: '86' },
    { code: 'IE', value: 'IRL', label: 'Ireland', phone: '353' },
    { code: 'IL', value: 'ISR', label: 'Israel', phone: '972' },
    { code: 'IT', value: 'ITA', label: 'Italy', phone: '39' },
    { code: 'MY', value: 'MYS', label: 'Malaysia', phone: '60' },
    { code: 'NO', value: 'NOR', label: 'Norway', phone: '47' },
    { code: 'PT', value: 'PRT', label: 'Portugal', phone: '351' },
    { code: 'SG', value: 'SGP', label: 'Singapore', phone: '65' },
    { code: 'ES', value: 'ESP', label: 'Spain', phone: '34' },
    { code: 'SE', value: 'SWE', label: 'Sweden', phone: '46' },
    { code: 'CH', value: 'CHE', label: 'Switzerland', phone: '41' },
    { code: 'GB', value: 'GBR', label: 'United Kingdom', phone: '44' },
    { code: 'VN', value: 'VNM', label: 'Viet Nam', phone: '84' }
];

const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.label,
    trim: true
});

const useStyle = makeStyles((theme) => ({
    container: {
        '& .MuiAutocomplete-root': {
            '& fieldset': {
                display: 'none'
            },
            '& .MuiAutocomplete-endAdornment': {
                top: 'calc(50% - 16px)',
                right: 4
            }
        },
        '& .MuiOutlinedInput-root.MuiInputBase-adornedStart': {
            padding: 0
        }
    },
    inputError: {
        // '& input': {
        //     '&::placeholder': {
        //         color: theme.palette.error.main
        //     }
        // }
    }
}))

const PhoneCountry = ({ error, label, phoneValue, maxLength = 20, translate = true, onChange, ...rest }) => {
    const classes = useStyle()
    const [phone, setPhone] = React.useState(phoneValue || { code: 'VN', value: 'VNM', label: 'Viet Nam', phone: '84' })
    const { t } = useTranslation()

    const onChangePhoneNumber = (event) => {
        if ((event.target.value === '') || (event.target.value && /^[0-9]*$/.test(event.target.value))) {
            const newState = { ...phone, ...{ phoneNumber: event.target.value } }
            onChange?.(newState)
            setPhone(newState)
        }
    }

    const onChangeCountry = (event, option, reason) => {
        if (reason === 'selectOption') {
            const newState = { ...phone, ...option }
            onChange?.(newState)
            setPhone(newState)
        }
    }

    const renderCountrySelect = () => {
        return (
            <Autocomplete
                required={true}
                onChange={onChangeCountry}
                value={phone || null}
                options={ListCountry}
                isOptionEqualToValue={(option, select) => {
                    return select && option.value === select.value
                }}
                getOptionLabel={(option) => {
                    return `+${option.phone}`
                }}
                filterOptions={filterOptions}
                disableClearable
                renderOption={(props, option) => {

                    return (
                        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={`${option.value} +${option.phone}`}>
                            <img
                                loading="lazy"
                                width="20"
                                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                alt=""
                            />
                            {`${option.label} (+${option.phone})`}
                        </Box>
                    )
                }}
                renderInput={(params) => {
                    return (
                        <React.Fragment>
                            <TextField
                                name={'password'}
                                {...params}
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                    form: {
                                        autocomplete: 'off'
                                    },
                                    style: { width: phone.phone?.length ? (phone.phone.length * 10 + 13) : 56, marginRight: -8 }
                                }}
                                required={true}
                                variant="outlined"
                                type="text" />
                        </React.Fragment>
                    )
                }}
            />
        )
    }

    return (
        <TextField
            {...rest}
            error={error}
            className={classnames(classes.container, {
                [classes.inputError]: !!error
            })}
            required
            variant={'outlined'}
            placeholder={t('lang_phone_number')}
            type="tel"
            label={label ? <Trans>{label}</Trans> : ''}
            value={phone.phoneNumber}
            onChange={onChangePhoneNumber}
            inputProps={{ maxLength }}
            InputProps={{
                startAdornment: <InputAdornment position="start">{renderCountrySelect()}</InputAdornment>
            }}
            fullWidth
        />
    );
}

export default PhoneCountry